import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import FalconCloseButton from '../../../components/common/FalconCloseButton';

/**
 * Modal para agregar una licencia a la orden detalle
 */
const ModalAgregarLicencia = ({
    modalStateAgregarLicencia,
    setModalStateAgregarLicencia,
    licenciasModal,
    selectedLicencia,
    setSelectedLicencia,
    guardarLicenciaOrdenDetalle
}) => {
    if (!modalStateAgregarLicencia.isOpen) return null;

    return (
        <Modal
            show={true}
            onHide={() => setModalStateAgregarLicencia({ isOpen: false, idOrdenDetalle: null })}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            top="top"
        >
            <Modal.Header>
                <Modal.Title>Lista de licencias para asignar</Modal.Title>
                <FalconCloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => setModalStateAgregarLicencia({ isOpen: false, idOrdenDetalle: null })}
                />
            </Modal.Header>
            <Modal.Body className="text-dark fs-2">
                {modalStateAgregarLicencia.isLoading ? (
                    <Skeleton />
                ) : (
                    <>
                        {licenciasModal && licenciasModal.length > 0 ? (
                            <>
                                <Row className="mb-3">
                                    <Col>
                                        <div className="mt-2"></div>
                                        <Form.Select
                                            aria-label="Selecciona la licencia"
                                            style={{ cursor: "pointer" }}
                                            onChange={e => setSelectedLicencia(e.target.value)}
                                        >
                                            <option>SELECCIONA EL UUID DE LA LICENCIA</option>
                                            {licenciasModal.map((licencia) => (
                                                <option value={licencia.idLicencia} key={licencia.idLicencia}>
                                                    {licencia.idLicencia} - {licencia.vUUIDLicencia}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="col-6">
                                        <Button
                                            onClick={() => guardarLicenciaOrdenDetalle(selectedLicencia, modalStateAgregarLicencia.idOrdenDetalle)}
                                            variant="primary"
                                            className="col-12"
                                        >
                                            Agregar
                                        </Button>
                                    </Col>

                                    <Col className="col-6">
                                        <Button
                                            onClick={() => setModalStateAgregarLicencia({ isOpen: false, idOrdenDetalle: null })}
                                            variant="danger"
                                            className="col-12"
                                        >
                                            Cancelar
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <>
                                <Row className="mb-3">
                                    <Col>
                                        <div role="alert" className="alert fs--1 alert-danger alert-dismissible fade show">
                                            <strong>El cliente no cuenta con licencias para asignar.</strong>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <button
                                            onClick={() => setModalStateAgregarLicencia({ isOpen: false, idOrdenDetalle: null })}
                                            className="btn btn-danger col-12"
                                        >
                                            Cancelar
                                        </button>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>
                )}
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

ModalAgregarLicencia.propTypes = {
    modalStateAgregarLicencia: PropTypes.shape({
        isOpen: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
        idOrdenDetalle: PropTypes.number
    }).isRequired,
    setModalStateAgregarLicencia: PropTypes.func.isRequired,
    licenciasModal: PropTypes.array.isRequired,
    selectedLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setSelectedLicencia: PropTypes.func.isRequired,
    guardarLicenciaOrdenDetalle: PropTypes.func.isRequired
};

export default ModalAgregarLicencia;
